import React, { useState } from 'react';
import { Form, FormControl } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import '../layout/SearchBar.css';

const SearchBar = ({ 
  placeholder = 'Search products...',
  className = '',
  size = 'md',
  onSubmit = null,
  onChange = null,
  value: externalValue = ''
}) => {
  const [searchQuery, setSearchQuery] = useState(externalValue || '');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    const query = searchQuery.trim();
    if (onSubmit) {
      onSubmit(query);
    } else if (query) {
      navigate(`/products?search=${encodeURIComponent(query)}`);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <Form 
      className={`search-form ${className}`} 
      onSubmit={handleSearch}
    >
      <div className="search-container w-100">
        <FormControl
          type="search"
          placeholder={placeholder}
          className={`search-bar ${searchQuery ? 'has-text' : ''} ${size ? `form-control-${size}` : ''}`}
          value={searchQuery}
          onChange={handleChange}
          aria-label="Search"
        />
        <button 
          type="submit" 
          className={`search-button ${searchQuery ? 'd-none' : ''}`} 
          aria-label="Search"
        >
          <FaSearch className="search-icon" />
        </button>
      </div>
    </Form>
  );
};

export default SearchBar;
